import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var Unsafe = function Unsafe(_ref) {
  var className = _ref.className,
      children = _ref.children,
      others = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
    className: mixClass('us-html', className),
    dangerouslySetInnerHTML: {
      __html: 'function' === typeof children ? children() : children
    }
  }));
};

export default Unsafe;